// Outback Comms theme JS
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.main-nav > li.has-mega');
  items.forEach(li => {
    let closeTimer;
    li.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      items.forEach(o => o.classList.remove('open'));
      li.classList.add('open');
    });
    li.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => li.classList.remove('open'), 120);
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.main-nav')) items.forEach(o => o.classList.remove('open'));
  });
  const drawer = document.querySelector('.mobile-drawer');
  document.querySelectorAll('.mobile-toggle').forEach(t =>
    t.addEventListener('click', () => {
      drawer && drawer.classList.toggle('open');
      document.body.classList.toggle('drawer-open');
    })
  );
  drawer && drawer.querySelectorAll('.md-accordion-head').forEach(h =>
    h.addEventListener('click', () => h.parentElement.classList.toggle('open'))
  );
  fetch('/cart.js').then(r => r.json()).then(c => {
    const badge = document.querySelector('.cart-count');
    if (badge) { badge.textContent = c.item_count; if (c.item_count === 0) badge.style.display = 'none'; }
  }).catch(()=>{});
  document.querySelectorAll('.var-swatch').forEach(g => {
    g.addEventListener('click', e => {
      if (e.target.classList.contains('var')) {
        g.querySelectorAll('.var').forEach(v => v.classList.remove('active'));
        e.target.classList.add('active');
      }
    });
  });
  document.querySelectorAll('.gallery-thumbs .thumb').forEach(t =>
    t.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumbs .thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const src = t.querySelector('img').src;
      const main = document.querySelector('.gallery-main img');
      if (main) main.src = src;
    })
  );
});
